import React, { lazy, Suspense } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import { loadPublicAuthRoutesWrapper } from './authRemote';
import { AuthRoutesLoading } from './AuthRoutesLoading';
import { isPublicAuthRoute } from './authRouteUtils';
import { isLocaleLandingRoute } from '../landingRouteUtils';
import { getPagesUrl } from '../utils/getPagesUrl';

const PublicAuthRoutesWrapper = lazy(loadPublicAuthRoutesWrapper);

export const PublicRoutes: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { hash, pathname, search } = useLocation();
  const { country, locale } = useParams();

  if (!isPublicAuthRoute(pathname) && country && locale) {
    // Bare locale landing root is not a deep link: post-login landing covers it and a returnUrl would force an extra full-page reload.
    const returnUrl =
      isLocaleLandingRoute(pathname) && !search && !hash
        ? undefined
        : `${pathname}${search}${hash}`;

    return (
      <Navigate
        to={
          getPagesUrl({
            country,
            locale,
            queryParameters: returnUrl ? { returnUrl } : undefined,
          }).loginPageUrl
        }
        replace
      />
    );
  }

  return (
    <Suspense fallback={<AuthRoutesLoading />}>
      <PublicAuthRoutesWrapper />
    </Suspense>
  );
};
